// Collection page behaviour: filter auto-submit, mobile filter drawer,
// grid/list toggle. Progressive enhancement — the filter form works
// without JS via its submit button.
if (!customElements.get('tk-collection')) {
  customElements.define(
    'tk-collection',
    class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-filter-form]');
        this.side = this.querySelector('[data-sidebar]');
        this.grid = this.querySelector('[data-grid]');

        if (this.form) {
          // Submit on change so the page reloads with new facets applied.
          this.form.addEventListener('change', (e) => {
            if (e.target.matches('input, select')) this.form.submit();
          });
        }

        const toggle = this.querySelector('[data-filter-toggle]');
        if (toggle && this.side) {
          toggle.addEventListener('click', () => {
            const open = this.side.dataset.open === 'true';
            this.side.dataset.open = String(!open);
            toggle.setAttribute('aria-expanded', String(!open));
          });
        }

        this.querySelectorAll('[data-view]').forEach((btn) => {
          btn.addEventListener('click', () => this.setView(btn.dataset.view));
        });

        // Restore the visitor's last choice.
        try {
          const saved = sessionStorage.getItem('tk-view');
          if (saved) this.setView(saved);
        } catch (e) {
          /* storage blocked — ignore */
        }
      }

      setView(view) {
        if (!this.grid) return;
        this.grid.classList.toggle('tk-cgrid--list', view === 'list');
        this.querySelectorAll('[data-view]').forEach((b) => {
          b.setAttribute('aria-pressed', String(b.dataset.view === view));
        });
        try {
          sessionStorage.setItem('tk-view', view);
        } catch (e) {
          /* ignore */
        }
      }
    }
  );
}